import React from "react";

import { ILongerGameStatisticsProps } from "@/types/LongerStatisticsTypes";

import { isPortrait } from "@/modules/commonMobile";

import { processMultilineStatistics, beadJSX } from "@/modules/statistics";

//Baccarat & IDN 4 Stand
export default class M22 extends React.Component<ILongerGameStatisticsProps> {
	statisticsArray = [];
	
	filtrate(history: any, pcode: string) {
		let bankers = 0, players = 0, ties = 0,
			bankerPairs = 0, playerPairs = 0,
			smalls = 0, bigs = 0;

		//is IDN 4 Stand
		const isIFS = pcode === "m28";
		
		history.forEach((item: any) => {
			//banker & player + pairs
			if (item.win === "banker") {
				bankers++;
				if (item.bankerPair)
					bankerPairs++;
				if (item.playerPair)
					playerPairs++;
			} else if (item.win === "player") {
				players++;
				if (item.bankerPair)
					bankerPairs++;
				if (item.playerPair)
					playerPairs++;
			} else ties++;
			
			//big small
			if (item.value <= 4)
				smalls++;
			else if (item.value > 4)
				bigs++;
		});
		
		//counts player and banker
		//display counts in grouped baccarat
		if (this.props.mobileHome)
			this.statisticsArray = [
				<div className="sl-roadmap-circle sl-roadmap-red"
					key={"mH_b"}>
					<div className="sl-baccarat-bead-value">
						B
					</div>
				</div>
				,
				<div
					key={"mH_b_val"}>
					{ bankers }
				</div>
				,
				<div className="sl-roadmap-circle sl-roadmap-blue"
					key={"mH_p"}>
					<div className="sl-baccarat-bead-value">
						P
					</div>
				</div>
				,
				<div key={"mH_p_val"}>
					{ players }
				</div>
			];
		else {
			/*
			this.statisticsArray = [
				<tr key="other_sa1">
					<td>
						<div className="sl-roadmap-circle sl-roadmap-red">
							<div className="sl-baccarat-bead-value">
								B
							</div>
						</div>
					</td>
					<td>
						<div className="sl-roadmap-circle sl-roadmap-blue">
							<div className="sl-baccarat-bead-value">
								P
							</div>
						</div>
					</td>
		
					<td>
						<div className="sl-roadmap-circle sl-roadmap-green">
							<div className="sl-baccarat-bead-value">
								T
							</div>
						</div>
					</td>
		
					<td>
						<div className="sl-roadmap-circle sl-roadmap-red">
							<div className="sl-baccarat-banker-pair sl-roadmap-red" />
						</div>
					</td>
		
					<td>
						<div className="sl-roadmap-circle sl-roadmap-blue">
							<div className="sl-baccarat-player-pair sl-roadmap-blue" />
						</div>
					</td>
		
					{
						!isIFS ?
						<td>
							<div className="sl-roadmap-circle sl-roadmap-grey">
								<div className="sl-baccarat-bead-value">
									S
								</div>
							</div>
						</td> : null
					}
			
					{
						!isIFS ?
						<td>
							<div className="sl-roadmap-circle sl-roadmap-grey">
								<div className="sl-baccarat-bead-value">
									B
								</div>
							</div>
						</td> : null
					}
				</tr>,
				<tr key="other_sa2">
					<td>
						<div>
							{ bankers }
						</div>
					</td>
					<td>
						<div>
							{ players }
						</div>
					</td>
		
					<td>
						<div>
							{ ties }
						</div>
					</td>
		
					<td>
						<div>
							{ bankerPairs }
						</div>
					</td>
		
					<td>
						<div>
							{ playerPairs }
						</div>
					</td>
		
					{
						!isIFS ?
						<td>
							<div>
								{ smalls }
							</div>
						</td> : null
					}
		
					{
						!isIFS ?
						<td>
							<div>
								{ bigs }
							</div>
						</td> : null
					}
				</tr>
			];*/

			//Static cells
			const statisticsCells = {
				top: isIFS ? [
					beadJSX("circle", "red", "B"),
					beadJSX("circle", "blue", "P"),
					beadJSX("circle", "green", "T"),
					beadJSX("circle", "red", "", "banker"),
					beadJSX("circle", "blue", "", "player")
				] : [
					beadJSX("circle", "red", "B"),
					beadJSX("circle", "blue", "P"),
					beadJSX("circle", "green", "T"),
					...(isPortrait() ? [null] : []),

					beadJSX("circle", "red", "", "banker"),
					beadJSX("circle", "blue", "", "player"),

					...(!isIFS ? 
					[
						beadJSX("circle", "grey", "S"),
						beadJSX("circle", "grey", "B")
					] : [])
				],
				
				bottom: isIFS ? [
					<div key={1}>{bankers}</div>,
					<div key={2}>{players}</div>,
					<div key={3}>{ties}</div>,
					<div key={4}>{bankerPairs}</div>,
					<div key={5}>{playerPairs}</div>
				] : [
					<div key={1}>{bankers}</div>,
					<div key={2}>{players}</div>,
					<div key={3}>{ties}</div>,
					...(isPortrait() ? [null] : []),

					<div key={4}>{bankerPairs}</div>,
					<div key={5}>{playerPairs}</div>,

					...(
						!isIFS ?
						[
							<div key={6}>{smalls}</div>,
							<div key={7}>{bigs}</div>
						] : []
					)
				]
			}

			//Output
			const cellsPerLine = isIFS ? 5 : 4;
			this.statisticsArray = [];

			processMultilineStatistics(this.statisticsArray, statisticsCells, cellsPerLine, isPortrait(), pcode);
		}
	}

	render() {
		if (!this.props.history)
			return null;

		this.filtrate(this.props.history, this.props.pcode);
		
		const statisticsTable = (
			<table><tbody>
				{ this.statisticsArray }
			</tbody></table>
		);
		
		//(this.props.mobileHome ? " mobile-home" : "")
		const mobileHomeStatistics = (
			<div className="game-statistics mobile-home">
				{ this.statisticsArray }
			</div>
		);
		
		return this.props.mobileHome ? (
			mobileHomeStatistics
		) : (
			<div className={
					"game-statistics m22" +
					(isPortrait() ? " multiline" : "") +
					(this.props.baccaratDarkMode ? " dark" : "")
				}>
				{ statisticsTable }
			</div>
		);
	}
}